export const LOGO_URL = 'https://files-public.monday.com/use1/3ec044c2-bb45-457a-8a30-ddbeb58a40e2/Sport%20Decisions%20Logo%20Design%20(1).png';
